<script setup>
import DataFilterChip from './DataFilterChip.vue'

const props = defineProps({
  filters: Object,
})
const dataQueryStore = inject('data-query-store')
const { t } = useI18n()
const data_filter_chip = ref(null)

const hasValues = computed(() => {
  const filterKeysWithValues = Object.keys(
    dataQueryStore?.value?.state?.value?.filters || {},
  )
  return props.filters
    .map(f => f.filterKey)
    .some(fk => filterKeysWithValues.includes(fk))
})
const simple = computed(() => props.filters?.length <= 3)

function clearAll() {
  const chips = data_filter_chip.value
  chips.forEach(chip => chip.clear())
}
</script>

<template>
  <div
    v-if="hasValues"
    class="data-filter-group-chips relative mt-6 flex flex-row flex-wrap items-center flex-gap-2"
  >
    <DataFilterChip
      v-for="(filter, index) in filters"
      :key="`filter_${index}`"
      ref="data_filter_chip"
      :filter="filter"
      :simple="simple"
    />
    <button
      class="flex flex-row items-center flex-gap-x-2 rounded-full px-3 py-3px text-xs text-secondary fw-bold ring-1 ring-secondary ring-inset"
      @click="clearAll"
    >
      <div>{{ t('Clear All') }}</div>
      <DSIcon
        icon="i-far-xmark-large"
        class="m-2px"
        size="16"
      />
    </button>
  </div>
</template>

<i18n>
{
  "en-us": {
    "Clear All": "Clear All"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Clear All": "Alle löschen"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Clear All": "Tout effacer"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Clear All": "Borrar todo"
}
</i18n>
